module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MDQuNTY3IiBoZWlnaHQ9IjMzNi42NDEiIHZpZXdCb3g9IjAgMCA0MDQuNTY3IDMzNi42NDEiPgogIDxwYXRoIGlkPSLjg5HjgrlfMzYwMiIgZGF0YS1uYW1lPSLjg5HjgrkgMzYwMiIgZD0iTS0yODUuODgsMzYwLjg4NVYxNzcuNThMMTE4LjY4NiwyNC4yNDRWMjA3LjU0OVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDI4NS44ODEgLTI0LjI0NCkiIGZpbGw9InJlZCIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/common/red_405.svg
// module id = ENz1
// module chunks = 0